import React, { useState, useEffect, useContext, memo } from "react";
import { useSnackbar } from "notistack";
import {
  Button,
  ButtonGroup,
  IconButton,
  TextField,
  Dialog,
  AppBar,
  Toolbar,
  Typography,
  Slide,
  Grid,
  MenuItem,
  Modal,
  Tooltip,
  FormControl,
  Box,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import LoadingIcon from "../../../../reusable-component/LoadingIcon";
import InputField from "../../../../reusable-component/InputField";
import { useAxios } from "../../../../contexts/AxiosProvider";
import { DataQualityApi } from "../../../../services/DataQualityService";
import { getEnvironmentConfig } from "../../../../constants/CloudConstant";

const styleLoading = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
};

const nameRegex = /^[a-zA-Z0-9_]{1,35}$/;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const INITIALSTATE = {
  path: "",
  profilingPath: "",
  action: "",
  persist: false,
  persist_type: "",
  alias: "",
  df: "",
  dataFrame: "",
  validation: "",
  sample_view: true,
};

const NodeModal_DataValidation = ({
  open,
  handleClose,
  nodeId,
  nodeName,
  nodes,
  edges,
  changeNodeName,
  setNodes,
  workflow,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const axios = useAxios();
  const [formField, setFormField] = useState(INITIALSTATE);
  const [disableForm, setDisableForm] = useState(false);
  const [headerName, setHeaderName] = useState([]);
  const [fetchedHeader, setFetchedHeader] = useState([]);
  const [tempHeader, setTempHeader] = useState([]);
  const [columns, setColumns] = useState([]);
  const [validationList, setValidationList] = useState([]);
  const [aliasError, setAliasError] = useState("");

  const [refreshModalOpen, setRefreshModalOpen] = useState(false);
  const handleRefreshModalOpen = () => setRefreshModalOpen(true);
  const handleRefreshModalClose = () => setRefreshModalOpen(false);

  const store = JSON.parse(sessionStorage.getItem("allNodes"));

  const getSourceData = () => {
    const findSrcNodeId = [];
    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (store && findSrcNodeId) {
      const header = [];
      let prev_alias;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
          }
        });
      });

      setFormField({ ...formField, df: prev_alias });

      setFetchedHeader(header);

      store.forEach((node) => {
        if (node.nodeId === nodeId) {
          setFormField(node.formField.validation);
          setHeaderName(node.sorting);
          setFetchedHeader(node.fetchedHeader);
          setColumns(node.sorting);
          setTempHeader(node.headerName);
          if (node.disabled) {
            setDisableForm(node.disabled);
          }
        }
      });
    }
  };

  useEffect(() => {
    setFormField(INITIALSTATE);
    setDisableForm(false);
    setFetchedHeader([]);
    setHeaderName([]);
    setColumns([]);
    getSourceData();
  }, [nodeId]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    // Validate alias field against nameRegex only if it has a value
    if (name === "alias") {
      if (fieldValue && !nameRegex.test(fieldValue)) {
        setAliasError("Special characters are not allowed");
      } else {
        setAliasError("");
      }
    }
    setFormField((prev) => ({
      ...prev,
      [name]: fieldValue,
    }));
  };

  const handleDataFrameChange = async (event) => {
    setFormField((prev) => ({
      ...prev,
      dataFrame: event.target.value,
      path: `${getEnvironmentConfig().BUCKET_NAME}/${workflow.engagement.clientEntity.clientName}/${workflow.engagement.engagementName}/${workflow.workflow_name}/Data_Processor/Output/Data_Profiling/${event.target.value}/validation`,
      profilingPath: `${getEnvironmentConfig().BUCKET_NAME}/${workflow.engagement.clientEntity.clientName}/${workflow.engagement.engagementName}/${workflow.workflow_name}/Data_Processor/Output/Data_Profiling/${event.target.value}/profiling`,
    }));

    const selectedDataFrame = fetchedHeader.find(
      (item) => item.df === event.target.value
    );

    handleHeadersFromPartFile(selectedDataFrame);
    handleValidations();
  };

  const handleSetColumn = (e, col) => {
    const columnsList = columns;
    let updatedCol;

    const updatedList = columnsList.map((el) => {
      if (el.column === col) {
        updatedCol = { ...el, validation_name: e.target.value };
        return updatedCol;
      }
      return el;
    });

    setColumns(updatedList);
  };

  const handleSetColumnParams = (e, col, param) => {
    const columnsList = columns;

    const updatedList = columnsList.map((el) => {
      if (el.column === col) {
        return { ...el, [param]: e.target.value };
      }
      return el;
    });

    setColumns(updatedList);
  };

  const handleHeadersFromPartFile = async (selectedDataFrame) => {
    let pathPrefix;
    const data = {
      path_prefix: selectedDataFrame.path,
      workflow_id: workflow.workflow_id,
    };
    try {
      const response = await DataQualityApi.getHeadersFromPartFileApi(
        axios,
        data
      );
      const columnObj = [];
      response.data.forEach((el) => {
        columnObj.push({ column: el.header_name, validation_name: "" });
      });
      setColumns(columnObj);
    } catch (error) {
      enqueueSnackbar("Server error! Something went wrong!", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    }
  };

  const handleValidations = async () => {
    try {
      const response = await DataQualityApi.getValidationListApi(axios);
      setValidationList(response.data);
    } catch (error) {
      if (error.response.status === 404) {
        enqueueSnackbar("Validation List not present on DB", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      } else {
        enqueueSnackbar("Server error! Something went wrong!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    }
  };

  useEffect(() => {
    handleValidations();
  }, []);

  const refreshAllState = () => {
    handleRefreshModalOpen();

    let updateNodes = JSON.parse(sessionStorage.getItem("updatedNodes")) || [];

    let count = 0;

    setNodes((nds) =>
      nds.map((node) => {
        if (count <= updateNodes.length && node.id === updateNodes[count]) {
          node.position.x -= 0.1;
          count++;
        }

        return node;
      })
    );

    updateNodes = updateNodes.filter((el) => el !== nodeId);

    sessionStorage.setItem("updatedNodes", JSON.stringify(updateNodes));

    const findSrcNodeId = [];

    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (findSrcNodeId.length === 0) {
      setFormField(INITIALSTATE);
      setDisableForm(false);
      setFetchedHeader([]);
      setHeaderName([]);
      setColumns([]);

      enqueueSnackbar("No source node is connected !!!", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      handleRefreshModalClose();
      return;
    }

    let nodesExist = false;

    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        nodesExist = true;
      }
    });

    if (store && findSrcNodeId) {
      const header = [];
      let prev_alias;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
          }
        });
      });

      setFormField({ ...formField, df: prev_alias });

      if (nodesExist) {
        store.forEach((node) => {
          if (node.nodeId === nodeId) {
            setFormField(node.formField);

            const nonExistingHeader = [];
            node.fetchedHeader.forEach((item) => {
              const index = header.findIndex((x) => x.df === item.df);

              if (index !== -1) {
                nonExistingHeader.push(item);
              }
            });

            header.forEach((el) => {
              const index = nonExistingHeader.findIndex((x) => x.df === el.df);

              if (index === -1) {
                nonExistingHeader.push(el);
              }
            });

            setFetchedHeader(nonExistingHeader);
            setHeaderName(node.sorting);
            setColumns(node.sorting);
          }
        });
      } else {
        setFetchedHeader(header);
      }
    }
    enqueueSnackbar("Data Refreshed!!!", {
      variant: "Success",
      autoHideDuration: 3000,
      anchorOrigin: { vertical: "top", horizontal: "right" },
    });
    handleRefreshModalClose();
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setDisableForm(false);
    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        setTempHeader(headerName);
      }
    });
    const getAllNodes = JSON.parse(sessionStorage.getItem("allNodes"));

    getAllNodes.forEach((el) => {
      if (el.nodeId === nodeId) {
        el["disabled"] = false;
      }
    });

    sessionStorage.setItem("allNodes", JSON.stringify(getAllNodes));

    const getElements = JSON.parse(sessionStorage.getItem("saved_node"));

    const newSavedElement = getElements.filter((el) => el !== nodeId);

    sessionStorage.setItem("saved_node", JSON.stringify(newSavedElement));
  };

  const handleResetForm = () => {
    setFormField(INITIALSTATE);
  };

  const compareTwoArrayOfObjects = (
    first_array_of_objects,
    second_array_of_objects
  ) => {
    return (
      first_array_of_objects.length === second_array_of_objects.length &&
      first_array_of_objects.every((element_1) =>
        second_array_of_objects.some(
          (element_2) =>
            element_1.header === element_2.header &&
            element_1.tableAlias === element_2.tableAlias &&
            element_1.alias === element_2.alias &&
            element_1.checked === element_2.checked
        )
      )
    );
  };

  const handleFormsubmit = async (e) => {
    e.preventDefault();

    const getAllNodes = JSON.parse(sessionStorage.getItem("allNodes") || "[]");

    if (getAllNodes.length > 0) {
      const newFormData = getAllNodes.filter((el) => el.nodeId !== nodeId);
      sessionStorage.setItem("allNodes", JSON.stringify(newFormData));
    }

    let y_axis;

    nodes.forEach((el) => {
      if (nodeId === el.id) {
        y_axis = parseInt(el.position.x, 10);
        el.data.label = formField.alias;
      }
    });

    const newHeaderName = [];

    headerName.forEach((item) => {
      newHeaderName.push({ ...item, tableAlias: formField.alias });
    });

    let equalArray;
    if (tempHeader.length > 0) {
      equalArray = compareTwoArrayOfObjects(tempHeader, newHeaderName);
    }

    const connectedNodes = [];

    if (!equalArray && tempHeader.length > 0) {
      edges.forEach((el) => {
        if (el.source === nodeId) connectedNodes.push(el.target);
      });

      let count = 0;

      setNodes((nds) =>
        nds.map((node) => {
          if (
            count <= connectedNodes.length &&
            node.id === connectedNodes[count]
          ) {
            node.position.x += 0.1;
            count++;
          }

          return node;
        })
      );
    }

    sessionStorage.setItem("updatedNodes", JSON.stringify(connectedNodes));

    const sendFormData = {
      y_axis,
      nodeId,
      nodeName,
      formField: { validation: formField, alias: formField.alias },
      disabled: true,
      step_name: nodeName,
      headerName: columns,
      fetchedHeader,
      sorting: columns,
    };

    changeNodeName(nodes);

    setDisableForm(true);

    sessionStorage.setItem("node", JSON.stringify(nodes));
    sessionStorage.setItem("edges", JSON.stringify(edges));

    const fetchNodesData = JSON.parse(
      sessionStorage.getItem("allNodes") || "[]"
    );
    fetchNodesData.push(sendFormData);

    sessionStorage.setItem("allNodes", JSON.stringify(fetchNodesData));

    const getElements = JSON.parse(
      sessionStorage.getItem("saved_node") || "[]"
    );
    getElements.push(nodeId);
    sessionStorage.setItem("saved_node", JSON.stringify(getElements));
  };

  const handleChecked = (event) => {
    setFormField({ ...formField, sample_view: event.target.checked });
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        TransitionComponent={Transition}
        style={{ width: "70%", marginLeft: "30%" }}
      >
        <form autoComplete="off" onSubmit={handleFormsubmit}>
          <AppBar sx={{ position: "relative", backgroundColor: "#fff" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
                sx={{ color: "#00043C" }}
              >
                <CloseIcon />
              </IconButton>
              <Typography
                sx={{ ml: 2, flex: 1, color: "#00043C" }}
                variant="h6"
                component="div"
              >
                {nodeName}
              </Typography>

              <Tooltip title="Refresh Schema" placement="left">
                <IconButton
                  edge="start"
                  onClick={refreshAllState}
                  aria-label="close"
                  sx={{ color: "#00043C" }}
                >
                  <RotateLeftIcon />
                </IconButton>
              </Tooltip>
              <ButtonGroup
                variant="contained"
                aria-label="outlined primary button group"
              >
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleResetForm}
                  disabled={disableForm}
                  className="outlined-button-color"
                >
                  Clear
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  className="outlined-button-color"
                  onClick={handleEdit}
                >
                  Edit
                </Button>
                <Button
                  type="submit"
                  size="small"
                  variant="contained"
                  disabled={disableForm}
                  className="button-color"
                >
                  Submit
                </Button>
              </ButtonGroup>
            </Toolbar>
          </AppBar>

          <div style={{ margin: "20px" }}>
            <div style={{ marginBottom: "20px" }}>
              <InputField
                name="alias"
                label="Alias"
                value={formField.alias}
                onChange={handleInputChange}
                size="small"
                disabled={disableForm}
                required
                error={!!aliasError}
                helperText={aliasError}
              />
              &emsp;
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={formField.sample_view}
                    onChange={handleChecked}
                    disabled={disableForm}
                  />
                }
                label="Sample View"
                sx={{ pl: 2, pt: 2 }}
              />
            </div>
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <TextField
                  id="outlined-select-currency"
                  select
                  required
                  label="Data Frame"
                  size="small"
                  value={formField.dataFrame}
                  onChange={handleDataFrameChange}
                  disabled={disableForm}
                  style={{ width: "100%", marginTop: "15px" }}
                >
                  {fetchedHeader.map((el, i) => (
                    <MenuItem key={i} value={el.df}>
                      {el.df}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
            {columns.length > 0 && (
              <TableContainer sx={{ maxHeight: 300 }}>
                <Table stickyHeader size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Columns</TableCell>
                      <TableCell>Validation</TableCell>
                      <TableCell>Params</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {columns.map((row, i) => {
                      return (
                        <TableRow hover key={i}>
                          <TableCell>{row.column}</TableCell>
                          <TableCell>
                            <TextField
                              id="standard-select-currency"
                              select
                              label="Validation"
                              name="validation_name"
                              disabled={disableForm}
                              value={row.validation_name}
                              onChange={(event) => {
                                handleSetColumn(event, row.column);
                              }}
                              style={{ width: "100%" }}
                              size="small"
                            >
                              <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                              {validationList.map((el, i) => (
                                <MenuItem key={i} value={el.validation_name}>
                                  <Tooltip title={el.description}>
                                    <span> {el.validation_name} </span>
                                  </Tooltip>
                                </MenuItem>
                              ))}
                            </TextField>
                          </TableCell>
                          <TableCell style={{ display: "flex" }}>
                            {validationList
                              .find(
                                (item) =>
                                  item.validation_name === row.validation_name
                              )
                              ?.params_list?.map((item) => (
                                <TextField
                                  name={item}
                                  label={item}
                                  size="small"
                                  value={row[item]}
                                  style={{ width: "200px" }}
                                  disabled={disableForm}
                                  onChange={(e) => {
                                    handleSetColumnParams(e, row.column, item);
                                  }}
                                />
                              ))}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <FormControl sx={{ minWidth: 230 }}>
                  <TextField
                    id="outlined-basic"
                    select
                    label="Persist"
                    variant="outlined"
                    value={formField.persist}
                    name="persist"
                    onChange={handleInputChange}
                    sx={{ mt: 2 }}
                    size="small"
                    disabled={disableForm}
                    required
                    InputProps={{
                      style: {
                        fontFamily: "'EB Garamond', serif ",
                        fontWeight: 600,
                      },
                    }}
                    InputLabelProps={{
                      style: { fontFamily: "'EB Garamond', serif " },
                    }}
                  >
                    <MenuItem value>true</MenuItem>
                    <MenuItem value={false}>false</MenuItem>
                  </TextField>
                </FormControl>
              </Grid>
              {formField.persist === true && (
                <Grid item xs={4}>
                  <FormControl sx={{ minWidth: 230 }}>
                    <TextField
                      id="outlined-basic"
                      select
                      label="Persist Type"
                      variant="outlined"
                      value={formField.persist_type}
                      name="persist_type"
                      onChange={handleInputChange}
                      sx={{ mt: 2 }}
                      size="small"
                      disabled={disableForm}
                      required
                    >
                      <MenuItem value="DISK_ONLY">DISK_ONLY</MenuItem>
                      <MenuItem value="DISK_ONLY_2">DISK_ONLY_2</MenuItem>
                      <MenuItem value="MEMORY_ONLY">MEMORY_ONLY</MenuItem>
                      <MenuItem value="MEMORY_ONLY_2">MEMORY_ONLY_2</MenuItem>
                      <MenuItem value="MEMORY_AND_DISK">
                        MEMORY_AND_DISK
                      </MenuItem>
                      <MenuItem value="MEMORY_AND_DISK_2">
                        MEMORY_AND_DISK_2
                      </MenuItem>
                    </TextField>
                  </FormControl>
                </Grid>
              )}
              <Grid item={4}>
                <FormControl sx={{ minWidth: 230 }}>
                  <InputField
                    name="action"
                    label="Action"
                    value={formField.action}
                    onChange={handleInputChange}
                    size="small"
                    disabled={disableForm}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </form>
      </Dialog>
      <Modal
        open={refreshModalOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLoading}>
          <LoadingIcon />
        </Box>
      </Modal>
    </div>
  );
};

export default memo(NodeModal_DataValidation);
